  <div class="tab">
    <ul class="nav nav-tabs" role="tablist">
      <li *ngFor="let tab of tabs; let i=index">
        <a id="{{tab.name}}-link" [ngClass]="tab.active ? 'active': ''" href="javascript:void(0)" (click)="activateTab(tab.name, true)" role="tab" data-toggle="tab">{{tab.title}}</a>
      </li>
    </ul>
  </div>
  <div class="mt-3 tab-content">
    <ng-container *ngComponentOutlet="activeComponent; inputs: activeComponentInputs"></ng-container>
  </div>
